import { createMessage as createErrorMessage } from '@common/api/graphql/errorMessage';
import { createMessage } from '@common/api/graphql/successMessage';
import type { ProjectState } from '@console/reducers/projects';
import {
  copyProjectToProjectDraft,
  copyProjectToProjectDraftFailure,
  copyProjectToProjectDraftSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import { registerProjectDraftThunk } from './registerProjectDraft';

export const copyProjectToProjectDraftSuccessThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    dispatch(
      copyProjectToProjectDraftSuccess(createMessage('キャンペーンをコピー'))
    );
    return Promise.resolve();
  };

export const copyProjectToProjectDraftFailureThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    dispatch(
      copyProjectToProjectDraftFailure(
        createErrorMessage('キャンペーンをコピー')
      )
    );
    return Promise.reject();
  };

export const copyProjectToProjectDraftThunk =
  (project: ProjectState): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(copyProjectToProjectDraft(project));

    return dispatch(registerProjectDraftThunk())
      .then(() => dispatch(copyProjectToProjectDraftSuccessThunk()))
      .catch(() => dispatch(copyProjectToProjectDraftFailureThunk()));
  };
